import {
  DigitalWalletType,
  PaymentMethodType,
} from 'modules/contribution/types'

import { SwitchSelector } from '@collegebacker/backer-ui/ui'

import styles from './GiftingNewPaymentMethod.module.scss'
import { activationDateValue, frequencyValue } from 'modules/contribution/LocalState'
import moment from 'moment'

type ActiveTabType = 0 | 1 | 2

export const GiftingNewPaymentMethod = ({
  children,
  view,
  setView,
  digitalWalletType,
  setActiveTab,
}: {
  children: any
  view: PaymentMethodType
  setView: (arg0: typeof view) => void
  digitalWalletType: DigitalWalletType
  setActiveTab: (arg0: ActiveTabType) => void
}) => {
  const activationDate = activationDateValue()
  const frequency = frequencyValue()

  // monthly contributions always start today (firstDay)
  const isToday = frequency === 'onetime' ?
    moment(activationDate).isSame(new Date(), 'day') :
    true

  return (
    <div className={styles.container}>
      <SwitchSelector
        className={styles.switch}
        options={[
          {
            label: 'Bank',
            value: 'bank-account'
          },
          {
            label: 'Card',
            value: 'credit-card'
          },
          ...(digitalWalletType && isToday
            ? [
                {
                  label: '',
                  value: 'digital-wallet',
                  paymentIcon:
                    digitalWalletType === 'applePay'
                      ? 'apple-pay'
                      : ('g-pay' as PaymentLogoTypes)
                }
              ]
            : [])
        ]}
        onChange={(option: SwitchSelectorOptionType) => {
          setActiveTab(option.index as ActiveTabType)
          setView(option.value as PaymentMethodType)
        }}
      />
      <div className={styles.body}>{children}</div>
    </div>
  )
}
